import { Flex, Spinner } from "@chakra-ui/react";
import { colors } from "../../Theme";

const LoaderFullwidth = () => {
  return (
    <Flex
      w="100%"
      direction="column"
      h={"calc(100vh - 64px - 36px)"}
      top={0}
      left={0}
      justify="center"
      align="center"
      backgroundColor={colors.badgeLight}
      opacity={0.5}
      position="absolute"
    >
      <Spinner size={"xl"} />
    </Flex>
  );
};

export default LoaderFullwidth;
